/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Pro subscription is processed through Polar.sh. When you subscribe, Polar.sh collects and processes your payment information according to their own privacy policy. We receive confirmation of your subscription status but do not have access to your full payment details.`)
};

const es_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra suscripción Pro se procesa a través de Polar.sh. Cuando te suscribes, Polar.sh recopila y procesa tu información de pago de acuerdo con su propia política de privacidad. Recibimos confirmación del estado de tu suscripción pero no tenemos acceso a tus datos de pago completos.`)
};

const de_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unser Pro-Abonnement wird über Polar.sh abgewickelt. Wenn Sie ein Abo abschließen, erfasst und verarbeitet Polar.sh Ihre Zahlungsinformationen gemäß deren eigener Datenschutzrichtlinie. Wir erhalten eine Bestätigung Ihres Abonnementstatus, haben aber keinen Zugriff auf Ihre vollständigen Zahlungsdaten.`)
};

const nl_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ons Pro-abonnement wordt verwerkt via Polar.sh. Wanneer u zich abonneert, verzamelt en verwerkt Polar.sh uw betalingsgegevens volgens hun eigen privacybeleid. We ontvangen een bevestiging van uw abonnementsstatus maar hebben geen toegang tot uw volledige betalingsgegevens.`)
};

const fr_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre abonnement Pro est géré par Polar.sh. Lorsque vous vous abonnez, Polar.sh collecte et traite vos informations de paiement conformément à leur propre politique de confidentialité. Nous recevons une confirmation de votre statut d’abonnement mais n’avons pas accès à vos coordonnées de paiement complètes.`)
};

const it_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nostro abbonamento Pro è elaborato tramite Polar.sh. Quando ti abboni, Polar.sh raccoglie ed elabora le tue informazioni di pagamento secondo la propria informativa sulla privacy. Riceviamo la conferma dello stato del tuo abbonamento ma non abbiamo accesso ai tuoi dati di pagamento completi.`)
};

const pt_br2_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nossa assinatura Pro é processada pela Polar.sh. Ao assinar, a Polar.sh coleta e processa suas informações de pagamento de acordo com sua própria política de privacidade. Recebemos confirmação do status da sua assinatura, mas não temos acesso aos seus dados completos de pagamento.`)
};

const pt_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nossa subscrição Pro é processada através do Polar.sh. Quando subscreve, o Polar.sh recolhe e processa a sua informação de pagamento de acordo com a sua própria política de privacidade. Recebemos confirmação do estado da sua subscrição, mas não temos acesso aos seus dados de pagamento completos.`)
};

const ja_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proサブスクリプションの処理はPolar.shを通じて行われます。登録時にPolar.shが支払い情報を収集・処理し、同社のプライバシーポリシーに従います。当社はサブスクリプションステータスの確認を受け取りますが、完全な支払い詳細にはアクセスしません。`)
};

const zh_privacy_section_6_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的Pro订阅通过Polar.sh处理。当您订阅时，Polar.sh会根据其自身的隐私政策收集和处理您的支付信息。我们会收到您的订阅状态确认，但无法访问您的完整支付详情。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_6_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_6_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_6_text", locale)
	if (locale === "en") return en_privacy_section_6_text(inputs)
	if (locale === "es") return es_privacy_section_6_text(inputs)
	if (locale === "de") return de_privacy_section_6_text(inputs)
	if (locale === "nl") return nl_privacy_section_6_text(inputs)
	if (locale === "fr") return fr_privacy_section_6_text(inputs)
	if (locale === "it") return it_privacy_section_6_text(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_6_text(inputs)
	if (locale === "pt") return pt_privacy_section_6_text(inputs)
	if (locale === "ja") return ja_privacy_section_6_text(inputs)
	return zh_privacy_section_6_text(inputs)
};